import React, { Component } from "react";
import { connect } from "react-redux";
import {  batchCarrierItemCode,  showCarrierItemCodeUploadDialog,  hideCarrierItemCodeUploadDialog, fetchCarrierItemCodeList, updateFiltersForCarrierItemCodeList, sortCarrierItemCodeList, clearCarrierItemCodeFilters,  } from "../../actions/carrierItemCodeAction";

import { validateAcceptedFields, validateRequiredFields, validateAuthority, parseObjectToString} from "../../utils/utils";
import { showError } from "../../actions/commonActions";
import { Box } from "@material-ui/core";
import FilesUpload from "../../components/FilesUpload";
import { fileUploadAcceptedFields,  fileUploadRequiredFields} from "../../utils/fields";
import DataTable from "../../components/DataTable";
import {  convertToCarrierItemCodeMappingObject,  formatCarrierItemCodeMappingRecord } from "../../utils/CsvObjectModifier/CarrierItemCodeMapping/CarrierItemCodeMapper";
import { CARRIER_ITEM_CODE_CSV_OBJECT } from "../../utils/CsvObjectModifier/CsvObjectFormat";
import { AUTHORITY_ADMIN } from "../../constant";
import Grid from "@material-ui/core/Grid";
import CarrierItemCodeUploadDialog from "../../components/dialogs/CarrierItemCode/CarrierItemCodeUploadDialog";
import PageTemplate from "../../components/PageTemplate";
import { USER_COUNTRY_CODES } from "../../constant";

class CarrierItemCodeList extends Component {
  constructor(props) {
    super(props);
     this.state = {
      showContentLoader: false,
      filters: {
        countryCode: [],
        carrierCode: '',
        itemCode: '',
        sku: '',
        description: '',
        createdAt: {
          from: null,
          to: null
        }
      }
    };
  }

  componentDidMount() {
    this.props.fetchCarrierItemCodeList('orderBy=createdAt&sort=desc');
    this.props.clearCarrierItemCodeFilters();
    this.props.sortCarrierItemCodeList('createdAt', 'desc');
  }

  onUpload = (data) => {
    let validatedRecords = {
      valid: true,
      lineNumberWithErrors: [],
      recordLimitExceeded: false,
      redundantCarrierItem: [],
      emptyRecord: false,
    };

    if (data.length <= 0) validatedRecords.emptyRecord = true;
    if (data.length > 5000) validatedRecords.recordLimitExceeded = true;

    const requiredFields = fileUploadRequiredFields["carrierItemCode"] || [];
    const acceptedFields = fileUploadAcceptedFields["carrierItemCode"] || [];

    data.forEach((row, index) => {
      validatedRecords.valid = row && validateAcceptedFields(acceptedFields, Object.keys(row)) &&  validateRequiredFields(requiredFields, row);

      if (!validatedRecords.valid) validatedRecords.lineNumberWithErrors.push(index + 4);
    });

    if (validatedRecords.lineNumberWithErrors.length === 0 && !validatedRecords.recordLimitExceeded && validatedRecords.redundantCarrierItem.length === 0 && !validatedRecords.emptyRecord) {
      this.props.showCarrierItemCodeUploadDialog(data);
    } 
    else {
      if (validatedRecords.emptyRecord) {
        this.props.showError({ response: { data: { translationKey: `0 record uploaded. Please fix and try again.` }}});
      }
      if (validatedRecords.recordLimitExceeded) {
        this.props.showError({ response: { data: {  translationKey: `Exceeded 5000 limit with ${data.length} uploaded records. Please fix and try again.` }}});
      }
      if (validatedRecords.lineNumberWithErrors.length > 0) {
        this.props.showError({  response: { data: {  translationKey: `Error in line ${validatedRecords.lineNumberWithErrors}. Please fix and try again.`  }}});
      } 
    }
  };

  uploadCarrierItemCode = async (data) => {
      this.props.hideCarrierItemCodeUploadDialog();
      const formattedData = convertToCarrierItemCodeMappingObject(data);

      try {
          this.setState({ showContentLoader: true });
          await this.props.batchCarrierItemCode(formattedData);
          await this.props.fetchCarrierItemCodeList('orderBy=createdAt&sort=desc');
      } catch (err) {
          this.props.showError({
          response: { data: { translationKey: err?.message || 'Upload failed. Please try again.' } }
          });
      } finally {
          this.setState({ showContentLoader: false });
      }
  };

  handleServerSideArticleCSVTemplateDownload = () => {
      const link = document.createElement("a");
      link.href = `${process.env.PUBLIC_URL}/assets/resources/import-template-carrierItemCode-carrierItemCode.csv`;
      link.download = "import-template-carrierItemCode-carrierItemCode.csv";
      link.click();
    };

  handleFilterUpdate = (filterKey, filterValue, multipleSelection) => {
    if (multipleSelection) {
      let filterState = this.props.carrierItemCodeFilters[filterKey] || [];
      filterState.includes(filterValue)
        ? filterState.splice(filterState.indexOf(filterValue), 1)
        : filterState.push(filterValue);
      filterValue = filterState;
    }
    this.props.updateFiltersForCarrierItemCodeList(filterKey, filterValue);
  };

  handleFilterReset = () => {
    this.props.clearCarrierItemCodeFilters();
    this.props.fetchCarrierItemCodeList("orderBy=createdAt&sort=desc");
  };

  handleSorting = (orderBy, sort) => {
    this.props.sortCarrierItemCodeList(orderBy, sort);

    const query = parseObjectToString(
      this.props.carrierItemCodeFilters,
      { orderBy, sort }
    );

    this.props.fetchCarrierItemCodeList(query);
  };

  render() {
    const defaultFields = {
      countryCode: this.props.authentication.loggedInUser.countryCode,
    };
    const sliceCsv = 2;

    const fields = [
      { name: "countryCode" },
      { name: "carrierCode" },
      { name: "itemCode"},
      { name: "sku" },
      { name: "description" },
      { name: "createdAt" },
      { name: "uploader.name" },
    ];

    const filterKeys = [
        {
            name: 'countryCode',
            type: 'checkBoxes',
            options: USER_COUNTRY_CODES
        },
        {
            name: 'carrierCode',
            type: 'textField'
        },
        {
            name: 'itemCode',
            type: 'textField'
        },
        {
            name: 'sku',
            type: 'textField'
        },
        {
            name: 'description',
            type: 'textField'
        },
        {
            name: 'createdAt',
            type: 'dateRangePicker'
        }
    ];

    return (
        <>
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <h3 style={{ paddingLeft: 30, paddingTop: 30 }}>Carrier Item Code</h3>
        </Box>

        <Grid container alignItems="center" justifyContent="center" style={{ marginTop: "8px" }}>
          <Grid item md={4}>
            <FilesUpload
                defaultFields={defaultFields}
                templateFile={`import-template-carrierItemCode-carrierItemCode.csv`}
                onUpload={this.onUpload}
                changeHeader={CARRIER_ITEM_CODE_CSV_OBJECT}
                sliceCsv={sliceCsv}
                isAdmin={validateAuthority(AUTHORITY_ADMIN,this.props.authentication.loggedInUser.authorities)}
                handleServerSideArticleCSVTemplateDownload={this.handleServerSideArticleCSVTemplateDownload}
                titleName={"messages.createCarrierItemCode"}
            />
          </Grid>
        </Grid>

        <PageTemplate>
          <DataTable
            fields={fields}
            items={this.props.carrierItemCode}
            entity="carrierItemCode"
            filterKeys={filterKeys}
            filterValues={this.props.carrierItemCodeFilters}
            onInputChange={this.handleFilterUpdate}
            onValueSubmit={() =>this.props.fetchCarrierItemCodeList(parseObjectToString(this.props.carrierItemCodeFilters))}
            sorting={this.props.carrierItemCodeSorting}
            sortingAvailable={true}
            onSort={(columnName, dir) => this.handleSorting(columnName, dir)}
            onCancel={this.handleFilterReset}
            showContentLoader={this.state?.showContentLoader}
            enableFilter={true}
            disableCell={true}
          />

          <CarrierItemCodeUploadDialog
              entity={this.props.carrierItemCodeUploadDialog?.entity}
              open={this.props.carrierItemCodeUploadDialog?.open}
              onReject={this.props.hideCarrierItemCodeUploadDialog}
              onAccept={this.uploadCarrierItemCode}
            />
        </PageTemplate>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  carrierItemCode: state.carrierItemCode.list || [],
  carrierItemCodeUploadDialog: state.carrierItemCode.carrierItemCodeUploadDialog,
  carrierItemCodeSorting: state.carrierItemCode.sorting || { column: null, direction: null },
  carrierItemCodeFilters: state.carrierItemCode.filters || { countryCode: [], carrierCode: '', itemCode: '', sku: '', description: '' },
  authentication: state.authentication,
});

export default connect(mapStateToProps, {
  batchCarrierItemCode,
  showCarrierItemCodeUploadDialog,
  hideCarrierItemCodeUploadDialog,
  fetchCarrierItemCodeList,
  updateFiltersForCarrierItemCodeList: updateFiltersForCarrierItemCodeList,
  clearCarrierItemCodeFilters: clearCarrierItemCodeFilters,
  showError,
  sortCarrierItemCodeList
})(CarrierItemCodeList);